import { Link } from "react-router-dom";
import { Leaf, Phone, Mail, MapPin } from "lucide-react";
import { companyInfo, services } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-sage-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-full bg-sage-700 flex items-center justify-center">
                <Leaf className="w-5 h-5 text-sage-100" strokeWidth={1.5} />
              </div>
              <div className="flex flex-col leading-none">
                <span className="font-serif text-xl tracking-wide">Rota Adriano Battista & C. S.a.s</span>
                <span className="text-[10px] uppercase tracking-[0.25em] mt-1 text-sage-300">
                  Il giardino dei desideri
                </span>
              </div>
            </div>
            <p className="text-sm text-sage-200/80 leading-relaxed max-w-xs">
              Creiamo giardini su misura da oltre {companyInfo.yearsExperience} anni. Passione, competenza e amore per il verde.
            </p>
          </div>

          {/* Servizi */}
          <div>
            <h4 className="font-serif text-lg mb-5 tracking-wide">Servizi</h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/servizi/${s.id}`}
                    className="text-sm text-sage-200/80 hover:text-white transition-colors"
                  >
                    {s.shortTitle}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigazione */}
          <div>
            <h4 className="font-serif text-lg mb-5 tracking-wide">Naviga</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-sage-200/80 hover:text-white">Home</Link></li>
              <li><Link to="/chi-siamo" className="text-sm text-sage-200/80 hover:text-white">Chi siamo</Link></li>
              <li><Link to="/servizi" className="text-sm text-sage-200/80 hover:text-white">Servizi</Link></li>
              <li><Link to="/fotogallery" className="text-sm text-sage-200/80 hover:text-white">Fotogallery</Link></li>
              <li><Link to="/contatti" className="text-sm text-sage-200/80 hover:text-white">Contatti</Link></li>
            </ul>
          </div>

          {/* Contatti */}
          <div>
            <h4 className="font-serif text-lg mb-5 tracking-wide">Contatti</h4>
            <ul className="space-y-4 text-sm text-sage-200/80">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-sage-300" strokeWidth={1.5} />
                <span>{companyInfo.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 shrink-0 text-sage-300" strokeWidth={1.5} />
                <a href={`tel:${companyInfo.phone.replace(/\s/g, "")}`} className="hover:text-white">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 shrink-0 text-sage-300" strokeWidth={1.5} />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-white break-all">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-sage-700/40 flex flex-col md:flex-row justify-between gap-4 text-xs text-sage-300">
          <span>© {new Date().getFullYear()} {companyInfo.fullName}. Tutti i diritti riservati.</span>
          <span>P.IVA / C.F. 03533620161</span>
        </div>
      </div>
    </footer>
  );
}
